import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Users2, Crown, UserCheck } from "lucide-react";
import api from "../../lib/api";

const ROL_COMITE_LABELS = {
    presidente: "Presidente",
    secretario: "Secretario",
    vocal_riesgos: "Vocal Riesgos",
    vocal_juridico: "Vocal Jurídico",
    vocal_operacion: "Vocal Operación",
};

const ROL_ICON = {
    presidente: Crown,
    secretario: UserCheck,
    vocal_riesgos: Users2,
    vocal_juridico: Users2,
    vocal_operacion: Users2,
};

export default function ComiteMiembros() {
    const [rows, setRows] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/gobierno/comite/miembros");
                setRows(data);
            } catch (err) {
                toast.error("No se pudo cargar", {
                    description: err?.response?.data?.detail,
                });
            }
        })();
    }, []);

    return (
        <div className="p-8 lg:p-10 space-y-6 max-w-[1200px]" data-testid="comite-miembros-page">
            <div>
                <div className="text-[11px] uppercase tracking-[0.3em] text-[color:var(--brand-dark-gold)] font-semibold mb-2">
                    Gobierno · Fase 14
                </div>
                <h1 className="font-display text-4xl tracking-tight flex items-center gap-3">
                    <Users2 className="h-8 w-8 text-[color:var(--brand-dark-gold)]" />
                    Miembros del Comité Fiduciario
                </h1>
                <p className="text-sm text-muted-foreground mt-1 max-w-2xl">
                    Órgano colegiado interno para dictámenes de aceptación, excepciones y revisión
                    de riesgos.
                </p>
            </div>

            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                {rows.map((m) => {
                    const Icon = ROL_ICON[m.rol_comite] || Users2;
                    return (
                        <div
                            key={m.miembro_id}
                            className="kpi-card"
                            data-testid={`miembro-${m.rol_comite}`}
                        >
                            <div className="flex items-center gap-3">
                                <div className="h-10 w-10 rounded-full bg-[color:var(--brand-dark-gold)]/10 flex items-center justify-center">
                                    <Icon className="h-5 w-5 text-[color:var(--brand-dark-gold)]" />
                                </div>
                                <div>
                                    <div className="font-display text-lg">{m.nombre}</div>
                                    <div className="text-[11px] uppercase tracking-widest text-muted-foreground">
                                        {ROL_COMITE_LABELS[m.rol_comite] || m.rol_comite}
                                    </div>
                                </div>
                            </div>
                            <div className="text-xs text-muted-foreground mt-3">
                                Alta: {m.fecha_alta?.slice(0, 10)}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
